import Card from 'components/Card/Card.jsx';

import moment from 'moment';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Row, Navbar, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import numeral from 'numeral';

import Loading from '../../components/Loading';
import logo from '../../assets/img/Icono.png';
//Redux
import { bindActionCreators } from 'redux';
import Feathers from '../../feathers.js';
import * as FranchiseSummaryActions from './redux/FranchiseSummaryActions';

moment.globalLocale = 'es';

class FranchiseSummaryIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dates: {
        date_initial: moment().startOf('month').format('YYYY-MM-DD'),
        date_final: moment().endOf('month').format('YYYY-MM-DD'),
      },
      franchiseSummary: [],
      finished: true,
      DateSelected: true,
      sortConfig: {},
      directioName: 'asc',
      directioTotal: 'asc',
      sortDirectioName: null,
      sortDirectioTotal: null,
    };
  }

  async componentWillMount() {}

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  generateFranchiseSummary = async () => {
    this.setState({ finished: false });

    const franchiseSummary = await Feathers.service('franchise-summary').find({
      query: {
        dates: {
          dateInitial: moment(
            this.state.dates.date_initial,
            'YYYY-MM-DD'
          ).utc(),
          dateFinal: moment(this.state.dates.date_final, 'YYYY-MM-DD')
            .endOf('day')
            .utc(),
        },
      },
    });
    franchiseSummary.sort(function (a, b) {
      return b.totalSales - a.totalSales;
    });
    this.setState({
      franchiseSummary: franchiseSummary,
      finished: true,
    });
  };

  onChangeDate = (path, value) => {
    var newDates;
    if (value) {
      newDates = immutable.set(this.state.dates, path, value);
      this.setState({
        dates: newDates,
        DateSelected: true,
      });
    } else {
      newDates = immutable.set(this.state.dates, path, value);
      this.setState({
        dates: newDates,
        DateSelected: false,
      });
    }
  };

  sortTable = (columnIndex) => {
    let { franchiseSummary, sortConfig } = this.state;
    let newSortConfig = { ...sortConfig };

    if (columnIndex === 0) {
      newSortConfig = {
        ...newSortConfig,
        key: 'franchiseName',
        direction:
          newSortConfig.key === 'franchiseName' &&
          newSortConfig.direction === 'asc'
            ? 'desc'
            : 'asc',
      };
    } else if (columnIndex === 1) {
      newSortConfig = {
        ...newSortConfig,
        key: 'totalQuotation',
        direction:
          newSortConfig.key === 'totalQuotation' &&
          newSortConfig.direction === 'asc'
            ? 'desc'
            : 'asc',
      };
    } else if (columnIndex === 2) {
      newSortConfig = {
        ...newSortConfig,
        key: 'quotes',
        direction:
          newSortConfig.key === 'quotes' && newSortConfig.direction === 'asc'
            ? 'desc'
            : 'asc',
      };
    } else if (columnIndex === 3) {
      newSortConfig = {
        ...newSortConfig,
        key: 'totalSales',
        direction:
          newSortConfig.key === 'totalSales' &&
          newSortConfig.direction === 'asc'
            ? 'desc'
            : 'asc',
      };
    } else if (columnIndex === 4) {
      newSortConfig = {
        ...newSortConfig,
        key: 'totalSalesCount',
        direction:
          newSortConfig.key === 'totalSalesCount' &&
          newSortConfig.direction === 'asc'
            ? 'desc'
            : 'asc',
      };
    } else if (columnIndex === 5) {
      newSortConfig = {
        ...newSortConfig,
        key: 'newClients',
        direction:
          newSortConfig.key === 'newClients' &&
          newSortConfig.direction === 'asc'
            ? 'desc'
            : 'asc',
      };
    }

    franchiseSummary.sort((a, b) => {
      if (newSortConfig.key === 'franchiseName') {
        return newSortConfig.direction === 'asc'
          ? a.name.localeCompare(b.name)
          : b.name.localeCompare(a.name);
      } else if (newSortConfig.key === 'totalQuotation') {
        return newSortConfig.direction === 'asc'
          ? a.totalQuotation - b.totalQuotation
          : b.totalQuotation - a.totalQuotation;
      } else if (newSortConfig.key === 'quotes') {
        return newSortConfig.direction === 'asc'
          ? a.totalQuotationCount - b.totalQuotationCount
          : b.totalQuotationCount - a.totalQuotationCount;
      } else if (newSortConfig.key === 'totalSales') {
        return newSortConfig.direction === 'asc'
          ? a.totalSales - b.totalSales
          : b.totalSales - a.totalSales;
      } else if (newSortConfig.key === 'totalSalesCount') {
        return newSortConfig.direction === 'asc'
          ? a.totalSalesCount - b.totalSalesCount
          : b.totalSalesCount - a.totalSalesCount;
      } else if (newSortConfig.key === 'newClients') {
        return newSortConfig.direction === 'asc'
          ? a.newClients - b.newClients
          : b.newClients - a.newClients;
      }
      return 0;
    });

    this.setState({
      franchiseSummary,
      sortConfig: newSortConfig,
    });
  };

  getSortIcon = (columnIndex) => {
    const { sortConfig } = this.state;

    if (sortConfig.key === 'franchiseName' && columnIndex === 0) {
      return sortConfig.direction === 'asc'
        ? 'fa fa-sort-asc'
        : 'fa fa-sort-desc';
    } else if (sortConfig.key === 'totalQuotation' && columnIndex === 1) {
      return sortConfig.direction === 'asc'
        ? 'fa fa-sort-asc'
        : 'fa fa-sort-desc';
    } else if (sortConfig.key === 'quotes' && columnIndex === 2) {
      return sortConfig.direction === 'asc'
        ? 'fa fa-sort-asc'
        : 'fa fa-sort-desc';
    } else if (sortConfig.key === 'totalSales' && columnIndex === 3) {
      return sortConfig.direction === 'asc'
        ? 'fa fa-sort-asc'
        : 'fa fa-sort-desc';
    } else if (sortConfig.key === 'totalSalesCount' && columnIndex === 4) {
      return sortConfig.direction === 'asc'
        ? 'fa fa-sort-asc'
        : 'fa fa-sort-desc';
    } else if (sortConfig.key === 'newClients' && columnIndex === 5) {
      return sortConfig.direction === 'asc'
        ? 'fa fa-sort-asc'
        : 'fa fa-sort-desc';
    }

    return 'fa fa-sort';
  };

  render() {
    let _this = this;

    let { DateSelected, dates, finished, franchiseSummary } = this.state;
    console.log({ franchiseSummary });
    return (
      <div className="main-content">
        {finished !== true ? (
          <Loading />
        ) : (
          <Grid fluid>
            <Row>
              <Col md={12}>
                <Card
                  title={
                    <div>
                      {'Concentrado Franquicias'}{' '}
                      <div className="pull-right header-table">
                        <Navbar.Form className="navbar-search-form">
                          <div className="pull-left header-table">
                            <label style={{ fontWeight: '250' }}>Desde :</label>
                            <input
                              id="date"
                              style={{ color: '#000000' }}
                              type="date"
                              className="form-control"
                              value={dates.date_initial}
                              onChange={(event) =>
                                this.onChangeDate(
                                  'date_initial',
                                  event.target.value
                                )
                              }
                              name="date"
                            />
                            <label style={{ fontWeight: '250' }}>Hasta :</label>
                            <input
                              id="date"
                              style={{ color: '#000000' }}
                              type="date"
                              className="form-control"
                              value={dates.date_final}
                              onChange={(event) =>
                                _this.onChangeDate(
                                  'date_final',
                                  event.target.value
                                )
                              }
                              name="date"
                            />
                            <Button
                              disabled={!DateSelected}
                              onClick={_this.generateFranchiseSummary}
                              style={{
                                backgroundColor: '#69a900',
                                border: '#69a900',
                                color: '#fff',
                                fontWeight: '500',
                                width: '200px',
                              }}
                            >
                              Generar
                            </Button>
                          </div>
                        </Navbar.Form>
                      </div>
                    </div>
                  }
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div>
                  <img
                    src={logo}
                    style={{ height: '40px', marginBottom: '10px' }}
                    alt="logoImg"
                  ></img>
                  <span
                    style={{
                      fontSize: '20px',
                      color: '#000',
                      fontWeight: '100',
                    }}
                  >
                    Informe de Franquicias
                  </span>
                  <div className="containerTable">
                    <table>
                      <thead>
                        <tr>
                          <th style={{ cursor: 'pointer' }}>
                            <div onClick={() => this.sortTable(0)}>
                              Nombre Franquicia{' '}
                              <i className={this.getSortIcon(0)} />
                            </div>
                          </th>
                          <th width={150} style={{ cursor: 'pointer' }}>
                            {' '}
                            <div onClick={() => this.sortTable(1)}>
                              Total Cotizado{' '}
                              <i className={this.getSortIcon(1)} />
                            </div>
                          </th>
                          <th width={150} style={{ cursor: 'pointer' }}>
                            <div onClick={() => this.sortTable(2)}>
                              Cotizaciones
                              <i className={this.getSortIcon(2)} />
                            </div>
                          </th>
                          <th width={150} style={{ cursor: 'pointer' }}>
                            <div onClick={() => this.sortTable(3)}>
                              Total Vendido
                              <i className={this.getSortIcon(3)} />
                            </div>
                          </th>
                          <th width={150} style={{ cursor: 'pointer' }}>
                            <div onClick={() => this.sortTable(4)}>
                              Ventas <i className={this.getSortIcon(4)} />
                            </div>
                          </th>
                          <th width={160} style={{ cursor: 'pointer' }}>
                            <div onClick={() => this.sortTable(5)}>
                              Nuevos Clientes
                              <i className={this.getSortIcon(5)} />
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {franchiseSummary
                          ? franchiseSummary.map(function (franchise, index) {
                              return (
                                <tr key={index}>
                                  <td align="left">
                                    {franchise.name ? franchise.name : 0}
                                  </td>
                                  <td align="right">
                                    {franchise.totalQuotation
                                      ? numeral(
                                          franchise.totalQuotation
                                        ).format('$0,0.00')
                                      : 0}
                                  </td>
                                  <td align="right">
                                    {franchise.totalQuotationCount
                                      ? franchise.totalQuotationCount
                                      : 0}
                                  </td>
                                  <td align="right">
                                    {franchise.totalSales
                                      ? numeral(franchise.totalSales).format(
                                          '$0,0.00'
                                        )
                                      : 0}
                                  </td>
                                  <td align="right" style={{ width: '15px' }}>
                                    {franchise.totalSalesCount
                                      ? franchise.totalSalesCount
                                      : 0}
                                  </td>
                                  <td align="right" style={{ width: '15px' }}>
                                    {franchise.newClients
                                      ? franchise.newClients
                                      : 0}
                                  </td>
                                </tr>
                              );
                            })
                          : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    FranchiseSummary: state.FranchiseSummary,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(FranchiseSummaryActions, dispatch);
};

const FranchiseSummaryConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(FranchiseSummaryIndex);

export default FranchiseSummaryConnect;



// WEBPACK FOOTER //
// ./src/views/FranchiseSummary/FranchiseSummaryIndex.jsx